export default __webpack_public_path__ + "static/media/icon-card.83c8d33f.svg";